export default __webpack_public_path__ + "static/media/tiktok.2945794d.svg";